export const environment = {
    production: true,
    firebase: {
        apiKey: 'AIzaSyBYAb3CdYBts1To7mowGMoqzwcqqZaGU2w',
        authDomain: 'vanconwebapps.firebaseapp.com',
        projectId: 'vanconwebapps',
        storageBucket: 'vanconwebapps.firebasestorage.app',
        messagingSenderId: '835788377075',
        appId: '1:835788377075:web:a0fce7b8e9ef2e053ba086',
        measurementId: 'G-C9CRVXQ1P3',
    },
}
